import { defineProfile } from "./define.js";

export const SERVICES_PROFILE = defineProfile("services", {
  labels: [],
  home: ["bookings_today", "quotes_waiting", "unread_chats", "ai_handoffs"],
  kpis: ["bookings", "quotes_accepted", "conversations", "response_time", "ai_handoffs"],
  panel: ["appointments", "quotes", "past_services"],
  quickActions: ["book_appointment", "new_quote", "send_reminder"],
  contactFields: [],
  aiTools: ["search_kb", "lookup_availability", "book_slot", "save_lead", "escalate"],
  cloudStarterMenu: "appointments_menu",
});
